// Pure cycling helpers for the chips. No React state.
//
// Status / priority cycle through fixed lists; assignee toggles between
// the two pair members. Each function is independently testable.

export const STATUS_CYCLE = ['TODO', 'IN_PROGRESS', 'DONE', 'CANCELLED']
export const PRIORITY_CYCLE = ['NONE', 'LOW', 'MEDIUM', 'HIGH']

export function nextStatus(current) {
  const idx = STATUS_CYCLE.indexOf(current)
  if (idx === -1) return STATUS_CYCLE[0]
  return STATUS_CYCLE[(idx + 1) % STATUS_CYCLE.length]
}

export function nextPriority(current) {
  const idx = PRIORITY_CYCLE.indexOf(current)
  if (idx === -1) return PRIORITY_CYCLE[0]
  return PRIORITY_CYCLE[(idx + 1) % PRIORITY_CYCLE.length]
}

export function nextAssignee(current, reportId, managerId) {
  if (!reportId || !managerId) return current
  return current === reportId ? managerId : reportId
}
